import { useEffect, useState } from "react";
import { fetchMyFeedback, submitFeedback } from "../../api.js";
import "./PublicSupport.css";

const currentPageUrl = () => (typeof window === "undefined" ? "" : window.location.href);
const createInitialForm = () => ({
  category: "bug_report",
  title: "",
  description: "",
  pageUrl: currentPageUrl(),
  priority: "normal",
});

export default function Feedback() {
  const [form, setForm] = useState(createInitialForm);
  const [items, setItems] = useState([]);
  const [state, setState] = useState({ busy: false, error: "", done: false });

  const load = () => fetchMyFeedback().then((response) => setItems(response.requests || [])).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  async function submit(event) {
    event.preventDefault();
    setState({ busy: true, error: "", done: false });
    try {
      await submitFeedback(form);
      setForm(createInitialForm());
      setState({ busy: false, error: "", done: true });
      load();
    } catch (error) {
      setState({ busy: false, error: error.message, done: false });
    }
  }

  return (
    <main className="public-page">
      <section className="public-card">
        <h1>Feedback &amp; change requests</h1>
        <p>Report a problem or suggest a focused improvement. Please do not include passwords, authentication secrets, or unnecessary sensitive data.</p>
        {state.done && <p className="support-notice">Thank you. Your request was submitted.</p>}
        {state.error && <p className="support-error">{state.error}</p>}
        <form className="support-grid" onSubmit={submit}>
          <Select label="Category" name="category" value={form.category} setForm={setForm} options={[["bug_report", "Bug report"], ["feature_request", "Feature request"], ["change_request", "Change request"], ["general_feedback", "General feedback"]]} />
          <Select label="Priority (optional)" name="priority" value={form.priority} setForm={setForm} options={[["", "Not specified"], ["low", "Low"], ["normal", "Normal"], ["high", "High"], ["urgent", "Urgent"]]} />
          <Field label="Title" name="title" value={form.title} setForm={setForm} />
          <Field label="Page / current URL (optional)" name="pageUrl" type="url" required={false} value={form.pageUrl} setForm={setForm} onFocus={(event) => event.target.select()} />
          <div className="support-field full">
            <label htmlFor="feedback-description">Description</label>
            <textarea id="feedback-description" required minLength="10" maxLength="5000" value={form.description} onChange={(event) => setForm((previous) => ({ ...previous, description: event.target.value }))} />
          </div>
          <button className="support-button" disabled={state.busy}>{state.busy ? "Submitting…" : "Submit request"}</button>
        </form>
        <h2>Your recent requests</h2>
        {items.length === 0 ? <p>No requests submitted yet.</p> : items.map((item) => (
          <div className="support-history-item" key={item.id}>
            <strong>{item.title}</strong>
            <p>{item.category.replaceAll("_", " ")} · {item.status.replaceAll("_", " ")} · {new Date(item.createdAt).toLocaleString()}</p>
          </div>
        ))}
      </section>
    </main>
  );
}

function Field({ label, name, setForm, required = true, ...inputProps }) {
  return (
    <div className="support-field">
      <label htmlFor={`feedback-${name}`}>{label}</label>
      <input id={`feedback-${name}`} name={name} required={required} minLength={required ? 3 : undefined} onChange={(event) => setForm((previous) => ({ ...previous, [name]: event.target.value }))} {...inputProps} />
    </div>
  );
}

function Select({ label, name, options, setForm, ...selectProps }) {
  return (
    <div className="support-field">
      <label htmlFor={`feedback-${name}`}>{label}</label>
      <select id={`feedback-${name}`} name={name} onChange={(event) => setForm((previous) => ({ ...previous, [name]: event.target.value }))} {...selectProps}>
        {options.map(([value, text]) => <option key={value} value={value}>{text}</option>)}
      </select>
    </div>
  );
}
